import React from "react";

const DocumentIcon = ({ width = 20, height = 20 }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 19.463 23.634"
    >
      <path
        id="Subtraction_2"
        data-name="Subtraction 2"
        d="M19.463,23.634H0V0H12.512V6.951h6.952V23.633ZM3.478,18.419v1.837H15.253V18.419Zm0-4.592v1.837H15.253V13.828Zm0-4.592v1.837H15.253V9.236ZM19.256,5.561H13.9V.207l5.352,5.352Z"
        fill="#0088e4"
      />
    </svg>
  );
};

export default DocumentIcon;



// WEBPACK FOOTER //
// ./src/assets/DocumentIcon.jsx